import { render } from "./BenefitsIcon.vue?vue&type=template&id=5654c7dd"
import script from "./BenefitsIcon.vue?vue&type=script&lang=js"
export * from "./BenefitsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__